export default __webpack_public_path__ + "static/media/back.ab6fcbee.svg";